import React from "react";
import { Link } from "react-router-dom";

const Privacy = () => {
  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-br from-[#020617] via-[#111827] to-[#1e293b] text-white font-calistoga relative overflow-hidden">
      {/* soft glow */}
      <div
        className="pointer-events-none absolute inset-0 opacity-45 mix-blend-soft-light
               bg-[radial-gradient(circle_at_top,_#facc1540,_transparent_60%)]"
        aria-hidden="true"
      />

      {/* Header (same as Home) */}
      <header className="">
        <div className="max-w-[1000px] mx-auto px-6 pt-8 flex items-center justify-between">
          <Link to="/">
            <span className="text-2xl font-medium tracking-wide">
              Ebbinghaus
            </span>
          </Link>
        </div>
      </header>

      {/* Main content */}
      <main className="relative z-10 px-6 py-16 mx-auto w-full max-w-[1000px] ">
        <div className="">
          <div className="rounded-3xl">
            <h1 className="text-3xl sm:text-4xl mb-8">
              Privacy Policy
            </h1>

            <div className="font-nunito text-sm sm:text-base text-white/85 space-y-4">
              <p>
                Ebbinghaus is intentionally simple. It does not collect any
                personally identifiable information from you.
              </p>
              <p>
                Ebbinghaus does not use analytics trackers.
              </p>
              <p>
                Ebbinghaus does not use cookies.
              </p>
              <p>
                Ebbinghaus does not contain adverts.
              </p>
              <p>
                Ebbinghaus does not require an internet connection.
              </p>
            </div>
          </div>
        </div>
      </main>

      {/* Footer (same as Home) */}
      <footer className="relative z-10 bg-black/60 text-white text-center text-sm py-4 mt-auto">
        <a
          href="https://josephmalam.com/"
          target="_blank"
          rel="noopener noreferrer"
          className="px-2 font-nunito text-sm font-semibold "
        >
          &copy;{" "}
          <span className="underline decoration-white/50">Joseph Malam</span>{" "}
          2022-2025
        </a>
        <div className="flex flex-row items-center justify-center pt-2 font-nunito text-xs">
          <Link to="/support" className="px-2 underline decoration-white/50">
            Support
          </Link>
          &bull;
          <Link to="/privacy" className="px-2 underline decoration-white/50">
            Privacy Policy
          </Link>
        </div>
      </footer>
    </div>
  );
};

export default Privacy;
